import { Infer, string, type } from "superstruct";

export const OfferConfigStruct = type({
  id: string(),
  reference_name: string(),
});

export type OfferConfigType = Infer<typeof OfferConfigStruct>;
